import script from "./MapFeatureSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./MapFeatureSelection.vue?vue&type=script&setup=true&lang=js"

import "./MapFeatureSelection.vue?vue&type=style&index=0&id=271976e4&lang=css"

const __exports__ = script;

export default __exports__